import { Plugin, EditorConfig, PluginConstructor } from "ckeditor5";
import { FlattenSimpleInterpolation } from "styled-components";

export class PluginWithStyles extends Plugin {
  static buildEditorStyles: (
    config: EditorConfig,
  ) => FlattenSimpleInterpolation | undefined;
}

export const isPluginWithStyles = (
  plugin: string | PluginConstructor,
): plugin is typeof PluginWithStyles =>
  typeof plugin !== "string" && "buildEditorStyles" in plugin;
